import React, { useState } from "react";
import Payment from "./StripeForms";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation } from "react-router-dom";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
const Checkout = () => {
    const location = useLocation();
    const { clientSecret } = location.state || {};
    const { plan, isUpgrading } = location.state || {}; // Get the plan data passed from the previous page

    const options = {
        clientSecret
    };
    return (
        <Elements stripe={stripePromise} options={options}>
            <Payment
                clientSecret={clientSecret}
                plan={plan}
                isUpgrading={isUpgrading}
            />
        </Elements>
    );
};

export default Checkout;
